import { Provider } from "@/src/models/auth.models";
import { getSSOUrl } from "@/src/services/api/auth.api";
import * as Linking from "expo-linking";
import * as WebBrowser from "expo-web-browser";
import { useTranslation } from "react-i18next";
import { Image, Platform, Pressable, View, Text } from "react-native";

type OauthButtonsProps = Readonly<{
  onSSOError?: (error: string, status?: string) => void;
}>;

export default function OauthButtons({ onSSOError }: OauthButtonsProps) {
  const { t } = useTranslation();

  const providers: { icon: any; provider: Provider }[] = [
    // {
    //   icon: require("../../../src/assets/images/flat-color-icons_google.png"),
    //   provider: "google",
    // },
    {
      icon: require("../../../src/assets/images/microsoft.webp"),
      provider: "microsoft",
    },
    // {
    //   icon: require("../../../src/assets/images/github-mark 1.png"),
    //   provider: "github",
    // },
  ];

  const handleSSOLogin = async (provider: Provider) => {
    try {
      const providerUrl = await getSSOUrl(provider);
      const redirectUrl = Linking.createURL("/auth/login");

      if (Platform.OS === "web") {
        if (typeof window !== "undefined") {
          sessionStorage.setItem("sso_provider", provider);
        }
        window.location.assign(providerUrl);
      } else {
        await WebBrowser.openAuthSessionAsync(providerUrl, redirectUrl);
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message?.error || t("ERROR_SSO_FAILED");
      const errorStatus = error?.response?.data?.message?.status;

      if (onSSOError) {
        onSSOError(errorMessage, errorStatus);
      }
    }
  };

  const iconSize = Platform.OS === "web" ? 32 : 28;

  return (
    <View className="flex-row justify-center gap-4 web:mb-4">
      {providers.map(({ icon, provider }, index) => (
        <Pressable
          key={index}
          onPress={() => handleSSOLogin(provider)}
          className="flex-1 flex-row web:h-[150%] web:w-[16%] w-16 h-12 border gap-4 border-primary rounded-2xl justify-center items-center active:opacity-80 hover:bg-ash-3"
        >
          <Image
            source={icon}
            style={{ width: iconSize, height: iconSize }}
            resizeMode="contain"
          />
          <Text className="text-onyx">{t('LABEL_SIGN_IN_MICROSOFT')}</Text>
        </Pressable>
      ))}
    </View>
  );
}
